// L'EFFACEUR — Page 404 custom
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-void flex items-center justify-center px-4 relative overflow-hidden">
      {/* Background grid effect */}
      <div className="absolute inset-0 opacity-10">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#00F5FF" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center relative z-10 max-w-lg">
        <p className="font-mono text-magenta-400 text-xs mb-4 tracking-wider">// ERREUR_404</p>
        <h1 className="font-orbitron text-7xl md:text-9xl font-black mb-4">
          <span className="text-cyan-400" style={{ textShadow: '0 0 30px rgba(0,245,255,0.6)' }}>4</span>
          <span className="text-magenta-400" style={{ textShadow: '0 0 30px rgba(255,0,255,0.6)' }}>0</span>
          <span className="text-cyan-400" style={{ textShadow: '0 0 30px rgba(0,245,255,0.6)' }}>4</span>
        </h1>
        <h2 className="font-orbitron text-xl md:text-2xl font-bold text-white mb-3">Page introuvable</h2>
        <p className="text-gray-400 mb-8">
          Cette page n'existe pas ou a été effacée.
          <br/>Vous pouvez retourner à l'accueil ou consulter votre dashboard.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/">
            <Button className="bg-cyan-400 text-black hover:bg-cyan-300 font-orbitron uppercase tracking-wider px-6 py-5 w-full sm:w-auto">
              <Home className="w-4 h-4 mr-2" /> Accueil
            </Button>
          </Link>
          <Button onClick={() => window.history.back()} variant="outline" className="border-magenta-400 text-magenta-400 hover:bg-magenta-400 hover:text-white px-6 py-5 w-full sm:w-auto">
            <ArrowLeft className="w-4 h-4 mr-2" /> Page précédente
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFoundPage;
